const palette = {
  black: '#000000',
  gray: '#7D7D7D',
  white: '#ffffff',
  green: '#C3F474',
  blue: '#52F4FF',
  backdrop: 'rgba(255,255,255,0.3)',
};

export default palette;
